import * as React from 'react';
import {useMemo} from 'react';

import {HeaderOrderButton} from '../header-order-button/HeaderOrderButton';
import {User} from '../../users/user.class';

export interface FocusedHeaderProps {
    hideHeaderOrderButton: boolean;
    userData: User;
}

export const FocusedHeader = ({hideHeaderOrderButton, userData}: FocusedHeaderProps) => {
    const user = useMemo(() => new User(userData), [userData]);

    /**
     * Template
     */
    return (
        <div>
            <div className="tw-h-[54px] tw-bg-gray-100 tw-flex tw-items-center">
                <div className="tw-max-w-[1432px] tw-pt-0 tw-px-4 tw-w-full tw-mx-auto">
                    <div>
                        <div
                            className={`tw-flex tw-text-center ${
                                hideHeaderOrderButton ? 'tw-justify-center' : ' tw-justify-between tw-align-middle tw-pt-1.5'
                            }`}
                        >
                            <div>
                                <a
                                    href="/"
                                    id="header_imperialLogo"
                                >
                                    <img
                                        alt="Imperial Logo"
                                        src="/dimg/imperial_logo_rgb.svg"
                                        width="80"
                                    />
                                </a>
                            </div>
                            {!hideHeaderOrderButton && (
                                <HeaderOrderButton
                                    hasActiveOrder={user.hasActiveOrder()}
                                    numOrderLines={parseInt(user.orderLines)}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div
                className="tw-relative tw-w-full tw-h-1 tw-overflow-hidden tw-z-[2] tw-bg-red-500 tw-hidden"
                style={{marginBottom: `-4px`}}
            >
                <div className="tw-bg-red-500" />
            </div>
        </div>
    );
};
